import { useReducer } from "react";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function useAutocompleteReducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else useAutocompleteReducer_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const useAutocompleteReducer = (callback, doNotRepeatSimilarRequest = false)=>{
    const initialState = {
        status: 'idle',
        items: [],
        hasMore: true,
        abortedReqIds: [],
        query: ''
    };
    const reducer = (state, { type, payload })=>{
        const isActionCancelled = (reqId)=>state.abortedReqIds.includes(reqId);
        switch(type){
            case "setQuery":
                return _object_spread_props(_object_spread({}, state), {
                    query: payload
                });
            case "setStatus":
                return isActionCancelled(payload.reqId) ? _object_spread({}, state) : _object_spread_props(_object_spread({}, state), {
                    status: payload.status
                });
            case "setItems":
                return isActionCancelled(payload.reqId) ? _object_spread({}, state) : _object_spread_props(_object_spread({}, state), {
                    items: payload.items
                });
            case "addItems":
                return isActionCancelled(payload.reqId) ? _object_spread({}, state) : _object_spread_props(_object_spread({}, state), {
                    items: [
                        ...state.items,
                        ...payload.items
                    ]
                });
            case "setHasMore":
                return isActionCancelled(payload.reqId) ? _object_spread({}, state) : _object_spread_props(_object_spread({}, state), {
                    hasMore: payload.hasMore
                });
            case "abortRequest":
                return _object_spread_props(_object_spread({}, state), {
                    abortedReqIds: [
                        ...state.abortedReqIds,
                        payload
                    ]
                });
            case "resetState":
                return initialState;
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(reducer, initialState);
    const setStatus = (payload)=>({
            type: "setStatus",
            payload
        });
    const setQuery = (payload)=>({
            type: "setQuery",
            payload
        });
    const setItems = (payload)=>({
            type: "setItems",
            payload
        });
    const addItems = (payload)=>({
            type: "addItems",
            payload
        });
    const setHasMore = (payload)=>({
            type: "setHasMore",
            payload
        });
    const abortRequest = (payload)=>dispatch({
            type: "abortRequest",
            payload
        });
    const resetState = ()=>({
            type: "resetState"
        });
    const requestItemsInner = (filter, type, reqId)=>_async_to_generator(function*() {
            if (doNotRepeatSimilarRequest) {
                if (state.query === filter.query && 'complete' === state.status) {
                    dispatch(setStatus({
                        status: 'complete',
                        reqId
                    }));
                    return state.items;
                }
            }
            try {
                dispatch(setQuery(filter.query));
                const items = (yield null == callback ? void 0 : callback(filter)) || [];
                'get' === type ? dispatch(addItems({
                    items,
                    reqId
                })) : dispatch(setItems({
                    items,
                    reqId
                }));
                dispatch(setHasMore({
                    hasMore: items.length >= filter.limit,
                    reqId
                }));
                dispatch(setStatus({
                    status: 'complete',
                    reqId
                }));
            } catch (err) {
                dispatch(setStatus({
                    status: 'failed',
                    reqId
                }));
            }
        })();
    const requestItems = (filter, type)=>{
        const reqId = Symbol('reqId');
        dispatch(setStatus({
            status: 'loading',
            reqId
        }));
        requestItemsInner(filter, type, reqId);
        return ()=>abortRequest(reqId);
    };
    const resetItems = ()=>dispatch(resetState());
    return _object_spread_props(_object_spread({}, state), {
        requestItems: callback ? requestItems : void 0,
        resetItems
    });
};
export { useAutocompleteReducer };
